import { InternalAxiosRequestConfig } from 'axios'
import firebase from 'firebase/compat/app'
import { getJWT } from './jwt_helper'

let firstTime = true
export const getAxiosInterceptor = (headers, useNewToken, skipInterceptor) => {
  return async (requestConfig: InternalAxiosRequestConfig) => {
    if (skipInterceptor) {
      return requestConfig
    }
    try {
      const jwt = await getJWT(useNewToken)
      const jwtHeaders = {}
      if (jwt) {
        jwtHeaders['Authorization'] = `Bearer ${jwt}`
      }
      if (firstTime) {
        await waitForAuthStateChange()
        firstTime = false
      }

      const firebaseToken = await firebase?.auth()?.currentUser?.getIdToken()
      if (!firebaseToken) {
        // Logs Service cannot be called here as it will cause a circular dependency

      }

      requestConfig.headers = {
        ...requestConfig.headers,
        ...headers,
        ...jwtHeaders,
        'token-id': firebaseToken || ''
      }
    } catch (e) {
      console.error(
        `Error in getting the current user token: ${JSON.stringify(e)}`
      )
    }
    return requestConfig
  }
}

export const getHeader = () => {
  return {
    channel: 'APP',
    source: 'WEB_USER',
    version: '2021-07-28',

    // add the translation language to headers (for translations API)
    // this header can be used by the servers to try and fetch the translations
    // available for any entry in the DB
    'x-translations-lang': localStorage.getItem('locale') || 'en-US'
  }
}

async function waitForAuthStateChange() {
  return new Promise<any>((resolve) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      unsubscribe() // Unsubscribe to avoid memory leaks
      if (user) {
        resolve(user) // User is signed in
      } else {
        resolve(undefined) // No user signed in
      }
    })
  })
}
